import { z } from 'zod';
import { isValidEmail } from '../validation/email';
import { checkOnlyValidNicknameChar, checkSpaceNicknameChar, checkValidWordNicknameChar } from '../validation/nickname';
import { checkConsecutiveChar, isValidPassword } from '../validation/password';

export const pre_trimmed_string = (zod_string: z.ZodString | z.ZodEffects<z.ZodString> = z.string()) =>
  z.preprocess((value) => (typeof value === 'string' ? value.trim() : value), zod_string);

export const required_string = pre_trimmed_string(z.string().min(1));
export const optional_string = pre_trimmed_string().optional();

/**
 * 인증번호
 * @example 123456
 * */
export const code = pre_trimmed_string(z.string().length(6));

export const name = pre_trimmed_string(z.string().min(1).max(30));

/**
 * user mobile
 * @example 01012341234
 * */
export const mobile = pre_trimmed_string(
  z
    .string()
    .regex(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/)
    .min(1),
);

export const nickname = pre_trimmed_string(
  z
    .string()
    .refine(
      (nickname) =>
        nickname === '' ||
        (nickname.length >= 2 &&
          nickname.length <= 10 &&
          checkOnlyValidNicknameChar(nickname) &&
          checkValidWordNicknameChar(nickname) &&
          checkSpaceNicknameChar(nickname)),
    ),
);

export const password = pre_trimmed_string(
  z
    .string()
    .min(10)
    .refine((password) => isValidPassword(password) && checkConsecutiveChar(password)),
);

/**
 * 이메일
 * @example abc@marpple.com
 * */
export const email = z
  .string()
  .email()
  .min(1)
  .transform((email) => email.toLowerCase().trim());

export const signup_email = z
  .string()
  .email()
  .min(1)
  .transform((email) => email.toLowerCase().trim())
  .refine((email) => isValidEmail(email));
